import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Star } from "lucide-react";
import { FcGoogle } from "react-icons/fc";
import { Reveal } from "./anim";
import { CONTACT } from "./config";

const reviews = [
  { quote: "Ponctualité irréprochable et un véhicule impeccable. Le chauffeur était discret et très professionnel. Je ne réserve plus qu'avec MN VTC pour mes transferts aéroport.", name: "Camille R.", role: "Transfert Béziers → Montpellier Aéroport" },
  { quote: "Un vrai moment de confort après un long vol. Accueil parfait, conduite souple et élégante. C'est exactement le service haut de gamme que je recherchais.", name: "Thomas L.", role: "Longue distance · Toulouse" },
  { quote: "Disponible tard le soir pour un événement, toujours avec le sourire et beaucoup de classe. Un service fiable et vraiment premium.", name: "Sophie M.", role: "Mise à disposition · Soirée" },
];

const Testimonials = () => {
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1);
  const go = (d) => { setDir(d); setI((p) => (p + d + reviews.length) % reviews.length); };
  const r = reviews[i];

  return (
    <section id="avis" data-testid="testimonials-section" className="relative border-y border-white/5 bg-ink-800 py-28 lg:py-40">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <Reveal>
          <div className="mb-14 flex items-center justify-between">
            <p className="text-xs uppercase tracking-[0.3em] text-rose">Ils nous font confiance</p>
            <div className="flex gap-1 text-rose">
              {Array.from({ length: 5 }).map((_, k) => <Star key={k} size={14} fill="currentColor" />)}
            </div>
          </div>
        </Reveal>

        <div className="relative min-h-[240px]">
          <AnimatePresence mode="wait" custom={dir}>
            <motion.blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, x: dir * 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: dir * -40 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <span className="mb-6 block font-serif text-7xl leading-none text-blush/30">“</span>
              <p className="font-serif text-3xl leading-snug tracking-tight text-blush sm:text-4xl">{r.quote}</p>
              <footer className="mt-8">
                <p className="text-sm font-semibold text-blush">{r.name}</p>
                <p className="text-xs uppercase tracking-[0.14em] text-muted-foreground">{r.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center gap-3">
          <button data-testid="testimonial-prev" onClick={() => go(-1)} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-rose/40 text-rose transition-colors hover:bg-rose/10">
            <ArrowLeft size={16} />
          </button>
          <button data-testid="testimonial-next" onClick={() => go(1)} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-rose/40 text-rose transition-colors hover:bg-rose/10">
            <ArrowRight size={16} />
          </button>
          <span className="ml-3 font-serif text-lg text-muted-foreground">0{i + 1} / 0{reviews.length}</span>
        </div>

        <a
          data-testid="google-reviews-cta"
          href={CONTACT.googleReviews}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-12 inline-flex items-center gap-3 rounded-full border border-blush/25 bg-blush/5 px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.14em] text-blush transition-colors hover:bg-blush/10"
        >
          <FcGoogle size={17} /> Voir tous nos avis sur Google
        </a>
      </div>
    </section>
  );
};

export default Testimonials;
